import addGame from "./addGame.ts";

export default {
	addGame,
};
